import React, { useRef, useEffect } from 'react';

const BackgroundSound = ({ isPlaying, audioSrc, volume = 0.1 }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = Math.max(0, Math.min(1, volume));
      if (isPlaying) {
        audioRef.current.play()
         .catch((error) => {
            console.error("Playback failed: ", error);
          });
      } else {
        audioRef.current.pause();
      }
    }
  }, [isPlaying, volume, audioSrc]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load();
    }
  }, [audioSrc]);

  if (!audioSrc) return null;

  return (
    <audio ref={audioRef} loop>
      <source src={audioSrc} />
    </audio>
  );
};

export default BackgroundSound;
